export enum ToastType {
  Undefined = 0,
  Success = 1,
  Warning = 2,
  Danger = 3,
  Info = 4,
}
